// extracted by mini-css-extract-plugin
export default {"products":"tC-z","card":"uC-z","oosMessaging":"vC-z"};